<template>
  <v-btn
    class="py-6 d-flex justify-start rounded"
    @click="connect"
    color="grey-lighten-4"
    elevation="3"
    data-testid="content-creator-connect-google-business-btn"
  >
    <r-img
      :src="KindTypeIcon.gmbNewsPost"
      width="30"
      height="30"
      class="mr-2 flex-grow-0"
    />
    {{ $t('buttons.social-media.connect-platform', { platform: platformLabel }) }}
  </v-btn>
</template>

<script setup lang="ts">
import { KindTypeIcon } from '../../enums/KindType'
import { ReadableSocialMedia } from '../../enums/SocialMedia'

type FeatureConfig = {
  postToGoogleBusiness?: boolean
}

type Props = {
  connectionWrapper: () => void | Promise<void>
  featureConfig: FeatureConfig | null
}
const props = defineProps<Props>()

// Emits
type Emits = {
  (e: 'featureEnabled', enabled: boolean): void
}
const emit = defineEmits<Emits>()

const platformLabel = ReadableSocialMedia.GOOGLE_BUSINESS

const connect = async () => {
  if (!props.featureConfig?.postToGoogleBusiness) {
    emit('featureEnabled', false)
    return
  }
  await props.connectionWrapper()
}
</script>
